interface BreakpointFlags {
  isXs: boolean
  isSm: boolean
  isMd: boolean
  isLg: boolean
  isXl: boolean
}

export const getItemsPerPage = ({
  isXs,
  isSm,
  isMd,
  isLg,
  isXl,
}: BreakpointFlags) => {
  if (isXs || isSm || isMd) return 3
  if (isLg) return 6
  if (isXl) return 9
  return 12
}
